import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { OrderSummaryLine } from "./orderSummarySubComponents";
/**
 * Renders additional items
 *
 * - If `groupItems` is true, displays a single summary line with the total cost of all items.
 * - If `groupItems` is false, displays one summary line per item with its own cost.
 *
 * @component
 * @param {CustomItemCost[]} items - The list of additional items with their costs.
 * @param {boolean} groupItems - Whether to group all items into a single summary line.
 * @param {string} label - The label to display when items are grouped.
 * @param {boolean} indent - Whether to indent the summary lines in the UI.
 *
 * @returns {JSX.Element} Rendered additional items as order summary lines.
 */
export const AdditionalItems = ({ items, groupItems, label, indent }) => {
    const totalAdditionalItemCost = items.reduce((sum, item) => { var _a; return sum + ((_a = item.totalCost) !== null && _a !== void 0 ? _a : 0); }, 0);
    return groupItems ? (_jsx(OrderSummaryLine, { label: label, value: totalAdditionalItemCost, indent: indent })) : (_jsx(_Fragment, { children: items.map((c) => (_jsx(OrderSummaryLine, { label: c.itemName, value: c.totalCost, indent: indent }, c.itemName))) }));
};
